export function parseVersionParts(v: string): number[] {
    return v.split(".").map((p) => Number.parseInt(p, 10)).map(n => Number.isFinite(n) ? n : 0);
}

export function compareVersionsAsc(a: string, b: string): number {
    const A = parseVersionParts(a);
    const B = parseVersionParts(b);
    const max = Math.max(A.length, B.length);
    for (let i = 0; i < max; i++) {
        const av = A[i] ?? 0;
        const bv = B[i] ?? 0;
        if (av !== bv) return av - bv;
    }
    return 0;
}

export function compareVersionsDesc(a: string, b: string): number {
    return compareVersionsAsc(b, a);
}

export function isVersionHigher(higher: string, lower: string): boolean {
    return compareVersionsAsc(higher, lower) > 0;
}

export function getMajor(version: string): number {
    return parseVersionParts(version)[0] ?? 0;
}

export function isNumericMajorKey(majorKey: string): boolean {
    return /^[0-9]+\.x$/.test(majorKey);
}

// Release candidate versions, e.g. "16.0.0-RC.1" / "16.0.0-RC1".
// Kept in sync with RC_TAG_PATTERN in the backend.
const RC_SUFFIX_PATTERN = /[-._]rc[-._]?\d*$/i;

export function isReleaseCandidate(version?: string): boolean {
    return !!version && RC_SUFFIX_PATTERN.test(version);
}